export const sportsIconMap: Record<string, string | null> = {
  Cricket: '/icons/sports/cricket.webp',
  Soccer: '/icons/sports/football.webp',
  Tennis: '/icons/sports/tennis.webp',
  'Table Tennis': '/icons/sports/table-tennis.webp',
  Esoccer: '/icons/sports/e-soccer.webp',
  'Horse Racing': '/icons/sports/horse-racing.webp',
  'Greyhound Racing': '/icons/sports/greyhound.webp',
  Basketball: '/icons/sports/basket-ball.webp',
  Wrestling: '/icons/sports/wrestling.webp',
  Volleyball: '/icons/sports/volleyball.webp',
  Badminton: '/icons/sports/badminton.webp',
  Snooker: '/icons/sports/snooker.webp',
  Darts: '/icons/sports/dart2.webp',
  Boxing: '/icons/sports/boxing.webp',
  'Mixed Martial Arts': '/icons/sports/boxing.webp',
  'American Football': '/icons/sports/american-football.webp',
  'E Games': '/icons/sports/e-games.webp',
  'Ice Hockey': '/icons/sports/ice-hockey.webp',
  Futsal: '/icons/sports/futsal.webp',
  Politics: '/icons/sports/politics.webp',
  'Motor Sports': '/icons/sports/motor-racing.webp',
  Kabaddi: '/icons/sports/kabbadi.webp',
};

export const qtechProviders = [
  'ALL',
  'Quickspin',
  'Spribe',
  'Spade Gaming',
  'Vivo Gaming',
  'JDB Gaming',
  'Aviatrix',
  "Play'n GO",
  'Holi',
  'JiLi',
  'Betgames',
  'Pragmatic Play Casino',
  'Gamzix',
  'Hacksaw',
  'KA Gaming',
  'Pragmatic Play Live',
  'Amigo Gaming',
  'AvatarUX',
  '1Spin4Win',
  'Playtech Casino',
  '7Mojos Live',
  '1x2 Gaming',
  'Evolution',
  'Turbo Games',
  'Brino Games',
  'King Midas',
  'Blueprint',
  '77 Gaming',
  'Evoplay',
  'SmartSoft',
  'Ezugi',
  'Rubyplay',
  'NetGame',
  '7Mojos Casino',
  'OneTouch',
  'RTG Slots',
  'PG Soft',
  'Qora',
  'Playtech Live',
  'Real Time Gaming',
];

// Fantasy / crash-game lobby (/fantasy-list) provider tabs.
// `label` is the chip text shown in the UI; `value` is sent to the API as the
// `provider` filter — adjust `value` to match the exact backend provider key
// if a tab returns no games.
export const fantasyProviders: { label: string; value: string }[] = [
  { label: 'SMART', value: 'SmartSoft' },
  { label: 'PASCAL', value: 'Pascal Gaming' },
  { label: 'POPOK', value: 'PopOK Gaming' },
  { label: 'OUR', value: 'Our Games' },
  { label: 'SPRIBE', value: 'Spribe' },
  { label: 'SCRATCH', value: 'Scratch' },
  { label: 'DARWIN', value: 'Darwin Gaming' },
  { label: 'GEMINI', value: 'Gemini' },
  { label: 'STUDIO21', value: 'Studio 21' },
  { label: 'BEON', value: 'Beon Gaming' },
  { label: 'JACKTOP', value: 'Jacktop' },
  { label: 'KINGMIDAS', value: 'King Midas' },
];

// Live Casino lobby (/live-casino) — provider tabs (1st row).
// `value` is sent to the API as the `provider` filter; adjust to the exact
// backend provider key if a tab returns no games.
export const liveCasinoProviders: { label: string; value: string }[] = [
  { label: 'CREEDROOMZ', value: 'CreedRoomz' },
  { label: 'EVOLUTION', value: 'Evolution' },
  { label: 'EZUGI', value: 'Ezugi' },
  { label: 'COCKFIGHT', value: 'Cockfight' },
  { label: 'RED CARAT', value: 'Red Carat' },
  { label: 'JACKTOP', value: 'JackTop' },
  { label: 'HOLI', value: 'Holi' },
];

// Live Casino lobby — category tabs (2nd row).
// `value` is sent to the API as the `category` filter.
export const liveCasinoCategories: { label: string; value: string }[] = [
  { label: 'ROULETTE', value: 'Roulette' },
  { label: 'BLACKJACK', value: 'Blackjack' },
  { label: 'BACCARAT', value: 'Baccarat' },
  { label: 'POKER', value: 'Poker' },
  { label: 'KENO', value: 'Keno' },
  { label: 'GAME SHOW', value: 'Game Show' },
  { label: 'OTHER', value: 'Other' },
];

// Per-provider category tabs (override the default list above).
// The first entry is the default category for that provider.
// `slug` (optional) overrides the URL slug derived from `label`.
// An empty `value` means "no category filter" (show all of the provider's games).
export const liveCasinoCategoriesByProvider: Record<
  string,
  { label: string; value: string; slug?: string }[]
> = {
  Evolution: [
    { label: 'BLACKJACK', value: 'Blackjack' },
    { label: 'ROULETTE', value: 'Roulette' },
    { label: 'BACCARAT', value: 'Baccarat' },
    { label: 'GAME SHOW', value: 'Game Show' },
    { label: 'OTHER', value: 'Other' },
  ],
  Ezugi: [
    { label: 'BLACKJACK', value: 'Blackjack' },
    { label: 'ROULETTE', value: 'Roulette' },
    { label: 'BACCARAT', value: 'Baccarat' },
    { label: 'OTHER', value: 'Other' },
  ],
  Cockfight: [
    // single tab — shows every Cockfight game (no category filter); URL slug is "other"
    { label: 'ALL GAMES', value: '', slug: 'other' },
  ],
  'Red Carat': [
    { label: 'BACCARAT', value: 'Baccarat' },
    { label: 'ROULETTE', value: 'Roulette' },
    { label: 'BLACKJACK', value: 'Blackjack' },
    { label: 'OTHER', value: 'Other' },
  ],
  JackTop: [
    { label: 'ROULETTE', value: 'Roulette' },
    { label: 'BLACKJACK', value: 'Blackjack' },
    { label: 'POKER', value: 'Poker' },
    { label: 'BACCARAT', value: 'Baccarat' },
  ],
  Holi: [
    // single tab — shows every Holi game (no category filter); URL slug is "roulette"
    { label: 'ALL CASINO', value: '', slug: 'roulette' },
  ],
};

// Slots lobby (/slots) — provider tabs (1st row).
// `value` is sent to the API as the `provider` filter.
/* ── OLD slot provider tabs (replaced by the full provider list below) ──
export const slotProviders: { label: string; value: string }[] = [
  { label: 'AMIGO', value: 'Amigo Gaming' },
  { label: 'JILI', value: 'JiLi' },
  { label: 'TURBO GAMES', value: 'Turbo Games' },
  { label: 'RED TIGER', value: 'Red Tiger' },
  { label: '1X2 GAMING', value: '1x2 Gaming' },
  { label: 'PRAGMATIC PLAY', value: 'Pragmatic Play Casino' },
  { label: 'PG SOFT', value: 'PG Soft' },
  { label: 'HACKSAW', value: 'Hacksaw' },
];
*/
export const slotProviders: { label: string; value: string }[] = [
  { label: 'JILI', value: 'JiLi' },
  { label: 'AMIGO', value: 'Amigo Gaming' },
  { label: 'TURBO GAMES', value: 'Turbo Games' },
  { label: 'RED TIGER', value: 'Red Tiger' },
  { label: '1X2 GAMING', value: '1x2 Gaming' },
  { label: 'BB GAMES', value: 'BB Games' },
  { label: 'BOOONGO', value: 'Booongo' },
  { label: 'DRAGOON SOFT', value: 'Dragoon Soft' },
  { label: 'POCKET GAME', value: 'Pocket Game' },
  { label: 'EVOPLAY', value: 'Evoplay' },
  { label: 'FANTASMA GAMES', value: 'Fantasma Games' },
  { label: 'HABANERO', value: 'Habanero' },
  { label: 'HACKSAW GAMING', value: 'Hacksaw' },
  { label: 'IRON DOG STUDIO', value: 'Iron Dog Studio' },
  { label: 'KALAMBA GAMES', value: 'Kalamba Games' },
  { label: 'LADY LUCK', value: 'Lady Luck' },
  { label: 'NOLIMIT CITY', value: 'Nolimit City' },
  { label: 'OMI GAMING', value: 'OMI Gaming' },
  { label: 'ONETOUCH', value: 'Onetouch' },
  { label: 'PLAYPEARLS', value: 'Playpearls' },
  { label: 'PUSH GAMING', value: 'Push Gaming' },
  { label: 'QUICKSPIN', value: 'Quickspin' },
  { label: 'RELAX GAMING', value: 'Relax Gaming' },
  { label: 'RTG SLOTS', value: 'RTG Slots' },
  { label: 'SPEARHEAD STUDIOS', value: 'Spearhead Studios' },
  { label: 'SLOTMILL', value: 'Slotmill' },
  { label: 'SPLITROCK GAMING', value: 'Splitrock Gaming' },
  { label: 'THUNDERKICK', value: 'Thunderkick' },
  { label: 'WOOHOO GAMES', value: 'Woohoo Games' },
  { label: 'YGGDRASIL', value: 'Yggdrasil' },
  { label: 'VIRTUAL GAMES', value: 'Virtual Games' },
  { label: 'KINGMIDAS', value: 'Kingmidas' },
  { label: 'EGT', value: 'EGT' },
];

// Slots lobby — category tabs (2nd row).
// `value` is sent to the API as the `category` filter.
/* ── OLD slot category tabs (replaced by the design's 4 tabs below) ──
export const slotCategories: { label: string; value: string }[] = [
  { label: 'NEW SLOTS', value: 'SLOT' },
  { label: 'POPULAR', value: 'Popular' },
  { label: 'JACKPOT', value: 'Jackpot' },
];
*/
export const slotCategories: { label: string; value: string; slug?: string }[] = [
  { label: 'TABLE GAME', value: 'Table Game' },
  { label: 'FISH GAME', value: 'Fish Game' },
  { label: 'SLOT GAME', value: 'Slot Game' },
  { label: 'CRASH GAME', value: 'Crash Game' },
];

// Per-provider slot category tabs (override the default list above).
// The first entry is that provider's default category.
// `slug` overrides the URL slug; empty `value` = no category filter (all games).
export const slotCategoriesByProvider: Record<
  string,
  { label: string; value: string; slug?: string }[]
> = {
  'Amigo Gaming': [
    // single tab — shows all Amigo games (no category filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
  ],
  'Turbo Games': [
    // single tab — shows all Turbo Games games (no category filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
  ],
  'Red Tiger': [
    // NEW SLOTS = all Red Tiger games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '4REEL', value: '4 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
    { label: '7REEL', value: '7 Reel' },
  ],
  '1x2 Gaming': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
  ],
  'BB Games': [
    // single tab 6REEL — URL slug is "table-game"
    { label: '6REEL', value: '6 Reel', slug: 'table-game' },
  ],
  Booongo: [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Dragoon Soft': [
    // NEW SLOTS = all Dragoon Soft games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: 'FISHING GAMES', value: 'Fishing Game' },
    { label: 'ARCADE GAMES', value: 'Arcade Game' },
  ],
  'Pocket Game': [
    // single tab — shows all Pocket Game games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
  ],
  Evoplay: [
    // NEW SLOTS = all Evoplay games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '4REEL', value: '4 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
    { label: '7REEL', value: '7 Reel' },
  ],
  'Fantasma Games': [
    // default 5REEL — URL slug is "table-game"
    { label: '5REEL', value: '5 Reel', slug: 'table-game' },
    { label: '6REEL', value: '6 Reel' },
    { label: '7REEL', value: '7 Reel' },
  ],
  Habanero: [
    // NEW SLOTS = all Habanero games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '4REEL', value: '4 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  // provider value for HACKSAW GAMING is 'Hacksaw'
  Hacksaw: [
    // default 4REEL — URL slug is "table-game"
    { label: '4REEL', value: '4 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Iron Dog Studio': [
    // default 5REEL — URL slug is "table-game"
    { label: '5REEL', value: '5 Reel', slug: 'table-game' },
    { label: '6REEL', value: '6 Reel' },
    { label: '7REEL', value: '7 Reel' },
  ],
  'Kalamba Games': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Lady Luck': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Nolimit City': [
    // NEW SLOTS = all Nolimit City games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '4REEL', value: '4 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'OMI Gaming': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  Onetouch: [
    // NEW SLOTS = all Onetouch games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '4REEL', value: '4 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Push Gaming': [
    // NEW SLOTS = all Push Gaming games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '4REEL', value: '4 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  Quickspin: [
    // NEW SLOTS = all Quickspin games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
    { label: '7REEL', value: '7 Reel' },
  ],
  'Relax Gaming': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'RTG Slots': [
    // NEW SLOTS = all RTG games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Spearhead Studios': [
    // NEW SLOTS = all Spearhead Studios games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  Slotmill: [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Splitrock Gaming': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
  ],
  Thunderkick: [
    // NEW SLOTS = all Thunderkick games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Woohoo Games': [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  Yggdrasil: [
    // default 3REEL — URL slug is "table-game"
    { label: '3REEL', value: '3 Reel', slug: 'table-game' },
    { label: '5REEL', value: '5 Reel' },
    { label: '6REEL', value: '6 Reel' },
  ],
  'Virtual Games': [
    // single tab — shows all Virtual Games games (no filter); URL slug is "table-game"
    { label: 'ALL GAMES', value: '', slug: 'table-game' },
  ],
  Kingmidas: [
    // single tab — shows all Kingmidas games (no filter); URL slug is "table-game"
    { label: 'ALL GAMES', value: '', slug: 'table-game' },
  ],
  Playpearls: [
    // NEW SLOTS = all PlayPearls games (no filter); URL slug is "table-game"
    { label: 'NEW SLOTS', value: '', slug: 'table-game' },
    { label: '3REEL', value: '3 Reel' },
    { label: '5REEL', value: '5 Reel' },
  ],
  EGT: [
    // single tab — shows all EGT games (no filter); URL slug is "table-game"
    { label: 'ALL GAMES', value: '', slug: 'table-game' },
  ],
};

export const casinoCategoryTabs = [
  { id: 1, name: 'All Casino', path: '/casino/all' },
  { id: 2, name: 'Roulette', path: '/casino/roulette' },
  { id: 3, name: 'Teenpatti', path: '/casino/teenpatti' },
  { id: 4, name: 'Poker', path: '/casino/poker' },
  { id: 5, name: 'Baccarat', path: '/casino/baccarat' },
  { id: 6, name: 'Dragon Tiger', path: '/casino/dragon tiger' },
  { id: 7, name: '32 Cards', path: '/casino/32 cards' },
  { id: 8, name: 'Andar Bahar', path: '/casino/andar bahar' },
  { id: 9, name: 'Lucky 7', path: '/casino/lucky7' },
  { id: 10, name: '3 Cards Judgement', path: '/casino/3 cards judgement' },
  { id: 11, name: 'Casino War', path: '/casino/casino war' },
  { id: 12, name: 'Worli', path: '/casino/worli' },
  // { id: 13, name: 'Sports', path: '/casino/sports' },
  { id: 13, name: 'Bollywood', path: '/casino/bollywood' },
  { id: 14, name: 'Lottery', path: '/casino/lottery' },
  { id: 15, name: 'Queen', path: '/casino/queen' },
  { id: 16, name: 'Race', path: '/casino/race' },
  { id: 17, name: 'Virtual', path: '/casino/virtual' },
  // { id: 18, name: 'Others', path: '/casino/others' },
];
